import { render } from "./Waiting.vue?vue&type=template&id=4d970d04&ts=true"
import script from "./Waiting.vue?vue&type=script&lang=ts"
export * from "./Waiting.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__